import { Injectable, signal } from '@angular/core';
import { Reservation } from '../models/sala.model';

@Injectable({ providedIn: 'root' })
export class ReservationEditService {
  private pendingEdit = signal<Reservation | null>(null);

  readonly pendingEditReservation = this.pendingEdit.asReadonly();

  requestEdit(reservation: Reservation): void {
    this.pendingEdit.set(reservation);
  }

  consume(): Reservation | null {
    const reservation = this.pendingEdit();
    this.pendingEdit.set(null);
    return reservation;
  }
}
